import { SHTypography } from "@components/design-systems";
import { MAAnalysisDataDTO } from "@models/managed-accounts/entities/step/fee";
import { ManagedAccountFieldType } from "@models/managed-accounts/enums/fieldType";
import { isEmpty, isEqual } from "lodash";
import { memo } from "react";
import { PerformanceNumberCell } from "../performance-number-cell";

interface CurrencyCellProps {
  analysisData?: MAAnalysisDataDTO;
}

export const CurrencyCell = memo(({ analysisData }: CurrencyCellProps) => {
  const { isMultiple, tooltip, value, valueInPercent } = analysisData || {};

  const isMultipleWithTooltip = [
    isMultiple,
    !isEmpty(tooltip),
    isEqual(value, ManagedAccountFieldType.Multiple),
  ].every(Boolean);

  return (
    <SHTypography variant="body3" colorVariant="third" lineHeight="120%">
      {isMultipleWithTooltip ? (
        <>Multiple</>
      ) : (
        <PerformanceNumberCell
          value={value}
          valueInPercent={valueInPercent}
          valueExcPerf={value}
          valueExcPerfInPercent={valueInPercent}
          renderValue={(value) => (
            <SHTypography
              variant="body3"
              colorVariant="third"
              lineHeight="120%"
            >
              {value}
            </SHTypography>
          )}
        />
      )}
    </SHTypography>
  );
});
